import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Footer from "../components/Footer";
import axios from "axios";
import { BrowserView, MobileView } from "react-device-detect";

import "./Home.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setRecommendedProductsAction } from "../store/actions/recommendedAction";
import { hideNavAction } from "../store/actions/showNavAction";
import { CAROUSEL_RESPONSIVE_CONFIG } from "../share/common";

function Home() {
  const recommendedProduct = useSelector((state) => state.recommendedProduct);
  const dispatch = useDispatch();

  useEffect(() => {
    const recommendedURL = process.env.REACT_APP_API_URL + `/recommended`;

    const getRecommendedProduct = async () => {
      const recommendedData = await axios({
        method: "GET",
        url: recommendedURL,
      });

      dispatch(setRecommendedProductsAction(recommendedData.data));
    };
    getRecommendedProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dispatch(hideNavAction());
  }, []);

  return (
    <div id="twc-home">
      <BrowserView>
        <video
          src={`/video/promo_video.mp4`}
          type="video/mp4"
          className="video_tag"
          autoPlay={true}
          loop={true}
          muted
          playsInline
          poster="https://cloudfront-us-east-1.images.arcpublishing.com/elfinanciero/U2ZKKDKS5OIXEHE7JGNX2BOURA.jpg"
        />
        <div id="header" className="d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column text-center">
            <h1>Que nunca te falte vino</h1>
            <h4>Los mejores vinos de la región</h4>
          </div>
        </div>
      </BrowserView>
      <MobileView>
        <img
          className="image_tag"
          src="https://cloudfront-us-east-1.images.arcpublishing.com/elfinanciero/U2ZKKDKS5OIXEHE7JGNX2BOURA.jpg"
          alt="presentationimage"
        />
        <div id="header" className="d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column text-center">
            <h1>Que nunca te falte vino</h1>
            <h4>Los mejores vinos de la región</h4>
          </div>
        </div>
      </MobileView>
      <div className="pt-5 z-index1 bg-light pb-5">
        <div className="container">
          <div className="text-center">
            <h5
              className="text-center pt-5 pb-3"
              style={{
                fontFamily: "Lobster Two, cursive",
                fontSize: "2rem",
                color: "rgb(119, 33, 33)",
              }}
            >
              <i className="far fa-thumbs-up"></i> Recomendados por nuestro sommelier
            </h5>
          </div>
          <Carousel responsive={CAROUSEL_RESPONSIVE_CONFIG} infinite={true} autoPlay={true}>
            {recommendedProduct.map((recommended) => (
              <Link
                className="wine-container"
                key={recommended.slug}
                to={`/producto/${recommended.slug}`}
              >
                <img
                  src={`${recommended.picture}`}
                  style={{ height: "20rem", objectFit: "cover" }}
                  alt="placeholder"
                />
                <div className="d-flex flex-column justify-content-center carousel_wine text-center align-items-center pt-2">
                  <span>{recommended.name}</span>
                  <span>$ {recommended.price}</span>
                </div>
              </Link>
            ))}
          </Carousel>
          <hr />
          <div className="">
            <h5
              className="text-center pt-5 pb-3 "
              style={{
                fontFamily: "Lobster Two, cursive",
                fontSize: "2rem",
                color: "rgb(119, 33, 33)",
              }}
            >
              <i className="far fa-star"></i> Productos Destacados{" "}
            </h5>
          </div>

          {recommendedProduct
            .filter((e) => e.featured)
            .map((p, i) => {
              const img = (
                <div className="col-lg-6 px-0 mt-5 mb-4 container_gif" key={p._id}>
                  <div
                    className="img-home"
                    style={{
                      backgroundImage: `url("${p.featuredPicture}")`,
                    }}
                  ></div>
                </div>
              );

              const text = (
                <div className="col-lg-6 text-ofert px-0 responsive-ofert-text">
                  <div>
                    <h5>{p.name}</h5>
                    <p>{p.featuredText}</p>
                    <Link className="btn btn-secondary mt-3" to={`/producto/${p.slug}`}>
                      Conocer más
                    </Link>
                  </div>
                </div>
              );

              return (
                <div className="row m-0 position-relative" key={p}>
                  {i % 2 === 0 ? img : text}
                  {i % 2 === 0 ? text : img}
                </div>
              );
            })}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
